export const HEADER_FIELDS = [
  {
    key: "job_no",
    label: "เลขที่เอกสาร",
    w: "7%",
    alignHeader: "center",
    align: "center",
    sortable: true,
  },
  {
    key: "job_time",
    label: "ครั้งที่เข้าบริการ",
    w: "7%",
    alignHeader: "center",
    align: "center",
    sortable: true,
  },
  {
    key: "job_date",
    label: "วันที่เอกสาร",
    alignHeader: "center",
    w: "7%",
    align: "center",
    sortable: true,
  },
  {
    key: "job_status_name",
    label: "สถานะ",
    w: "7%",
    alignHeader: "center",
    align: "center",
    sortable: true,
  },
  {
    key: "srv_date",
    label: "วันที่เข้าบริการ",
    w: "7%",
    alignHeader: "center",
    align: "center",
    sortable: true,
  },
  {
    key: "AR_Code",
    label: "รหัสลูกค้า",
    w: "7%",
    alignHeader: "center",
    align: "center",
    sortable: true,
  },
  {
    key: "AR_Name",
    label: "ชื่อลูกค้า",
    w: "20%",
    alignHeader: "center",
    align: "start",
    sortable: true,
  },
  {
    key: "job_desc",
    label: "รายละเอียด",
    w: "15%",
    alignHeader: "center",
    align: "start",
    sortable: true,
  },
  {
    key: "job_detail",
    label: "รายละเอียดการปฎิบัติงาน",
    w: "15%",
    alignHeader: "center",
    align: "start",
    sortable: true,
  },
];

export const DETAIL_FIELDS = [
  {
    key: "Doc_Date",
    label: "วันที่",
    w: "12%",
    alignHeader: "center",
    align: "center",
    numeric: false,
  },
  {
    key: "Doc_No",
    label: "เลขที่เอกสาร",
    w: "12%",
    alignHeader: "center",
    align: "center",
    numeric: false,
  },
  {
    key: "Item_Code",
    label: "รหัสสินค้า",
    w: "17%",
    alignHeader: "center",
    align: "center",
    numeric: false,
  },
  {
    key: "Item_Name",
    label: "ชื่อสินค้า",
    w: "50%",
    alignHeader: "center",
    align: "center",
    numeric: false,
  },
  {
    key: "Item_Price_Unit",
    label: "ราคา/หน่วย",
    w: "12%",
    alignHeader: "center",
    align: "end",
    numeric: true,
  },
  {
    key: "Item_Qty",
    label: "จำนวน",
    w: "8%",
    alignHeader: "center",
    align: "end",
    numeric: true,
  },
  {
    key: "NetTotal",
    label: "รวมเงิน",
    w: "14%",
    alignHeader: "center",
    align: "end",
    numeric: true,
  },
  {
    key: "Item_Discount",
    label: "ส่วนลด",
    w: "8%",
    alignHeader: "center",
    align: "end",
    numeric: true,
  },
  {
    key: "Item_Total",
    label: "ราคารวม",
    w: "8%",
    alignHeader: "center",
    align: "end",
    numeric: true,
  },
];
